/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import MoneyCounter from './MoneyCounter';

class MoneyCounterButton extends React.Component {

    state: State = {
        keyboardVisible: false
    };

    static propTypes = {
        msg: React.PropTypes.object,
        className: React.PropTypes.string.isRequired,
        removedClassName: React.PropTypes.string,
        coins: React.PropTypes.string,
        onSubmit: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.openKeyboard = this.openKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    openKeyboard(open) {
        this.setState({keyboardVisible: open});
    }

    onSubmit(val, coins) {
        const {onSubmit} = this.props;
        onSubmit(val, coins);
        this.openKeyboard(false);
    }

    render() {
        const {keyboardVisible} = this.state;
        const {className, removedClassName, coins, msg} = this.props;
        const cn = keyboardVisible ? className.replace(removedClassName, '') : className;

        return (
            <div className={cn}>
                <div className="boxBtn-inner" onClick={() => this.openKeyboard(true)}>
                    {msg.moneyCount.count}
                </div>
                {keyboardVisible &&
                <MoneyCounter onClose={() => this.openKeyboard(false)}
                              coins={coins}
                              onSubmit={this.onSubmit}/>
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale]
}))(MoneyCounterButton);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/MoneyCounterButton.js